"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeRamp = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = require("react");
var _useTheme = require("../../../theme/utils/useTheme");
var _deprecatedTypeRampConstants = require("../constants/deprecatedTypeRampConstants");
/** @jsxRuntime classic */
/** @jsx jsx */

/**
 * @deprecated please use the TypeRampV2 components instead.
 */

const ComponentBase = (0, _styled.default)("div")``;

/**
 * @deprecated please use the TypeRampV2 components instead.
 */
const TypeRamp = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    renderAs,
    children,
    clientId,
    variant,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    component,
    theme,
    ...restStyles
  } = _deprecatedTypeRampConstants.typeRampDefinitions[variant];
  // We need to perform this little remapping for a couple reasons:
  // 1. The TypeRamp component only supports lodestar-light (light) and oldestar right now.
  // 2. The typeRampDefinitions are part of the public API and cannot be changed to use the
  //    more centralized functions from src/util/theme.
  const fallbackThemeMode = (() => {
    switch (themeMode) {
      case "ursa-light":
      case "ursa-dark":
      case "lodestar-light":
        return "light";
      case "oldestar":
        return "oldestar";
    }
  })();
  const styleObject = {
    ...restStyles,
    ...theme[fallbackThemeMode]
  };
  const element = renderAs ? renderAs : component;

  // Memoizing this to ensure we won't create a new component each time.
  // withComponent returns a new component.
  // do we need the theme in here too??
  const ComponentRoot = (0, _react.useMemo)(() => {
    return ComponentBase.withComponent(element);
  }, [element]);
  return (0, _core.jsx)(ComponentRoot, (0, _extends2.default)({
    ref: ref,
    "data-client-id": clientId,
    css: styleObject
  }, rest), children);
});
exports.TypeRamp = TypeRamp;
TypeRamp.displayName = "TypeRamp";
//# sourceMappingURL=TypeRamp.js.map